import { render, staticRenderFns } from "./productawardDetail.vue?vue&type=template&id=eb51cf98&scoped=true"
import script from "./productawardDetail.vue?vue&type=script&lang=js"
export * from "./productawardDetail.vue?vue&type=script&lang=js"
import style0 from "./productawardDetail.vue?vue&type=style&index=0&id=eb51cf98&prod&lang=scss&scoped=true"
import style1 from "./productawardDetail.vue?vue&type=style&index=1&id=eb51cf98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb51cf98",
  null
  
)

export default component.exports